module.exports = __webpack_public_path__ + "static/media/RobotoMono-Thin.564755b4.ttf";